import { createContext, useContext } from "react";

import type { Editor } from "@tiptap/react";

import { type MenuCommands, createMenuCommands } from "./commands";
import type { EditorSettings } from "./editorTypes";

export type EditorContextValue = {
  editor: Editor | null;
  isEditable: boolean;
  settings: EditorSettings;
  commands: MenuCommands;
};

export const EditorContext = createContext<EditorContextValue>({
  editor: null,
  isEditable: false,
  settings: {},
  commands: createMenuCommands(null),
});

export const useEditorContext = () => useContext(EditorContext);

/** The editor instance, or `null` before it has been created. */
export const useRichTextEditor = () => useContext(EditorContext).editor;
